import AnimeCardControls from './AnimeCardControls'

export default AnimeCardControls